// extracted by mini-css-extract-plugin
export default {"root_scroller":"U-","flex_container":"V-","container":"W-","scroller":"X-","indicator":"Y-","scrollButtons":"Z-","selected":"a0","root_tab":"b0","root_tab_scrollable":"c0","root_scroller_mob":"e0","scroller_mob":"f0","indicator_mob":"g0","selected_mob":"h0","root_tab_mob":"i0","root_tab_mob_scrollable":"j0"};
    if(module.hot) {
      // 1721922367796
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  